import SupervisorDetailPage from "@/app/(app)/(crew)/home/[shift]/supervisor/[supervisor]";
export default SupervisorDetailPage;
